import { Space } from '@gr-monorepo/common/ui';
import { Container, Header } from 'features/shared/ui/Page';
import React from 'react';
import Banners from '../shared/Banners/Banners';
import { useBannersContext } from '../shared/Banners/BannersContext';
import useUserData from 'hooks/useUserData';
import { Wrap } from './MainPageStyled';
import { School } from './components/School';
import { Webinars } from './components/Webinars';
import { Portfolio } from './components/Portfolio';
import { Olympiads } from './components/Olympiads';
import useGratitudeCheck from 'hooks/useGratitudeCheck';
import { FunctionalLiteracy } from './components/MunicipalityTasks/FunctionalLiteracy';
import { SafeTerritory } from './components/MunicipalityTasks/SafeTerritory';
import RegionalRating from './components/RegionalRating';
import Kpk from './components/Kpk';
import MultiStageOlympiad from './components/MultiStageOlympiad';
import { VectorSurvey } from './components/VectorSurvey/VectorSurvey';
import PriorityProjects from './components/PriorityProjects';
import usePriorityProjectsStore from './components/PriorityProjects/usePriorityProjectsStore';
import { useConfiguratorsContext } from 'hooks/useConfiguratorsContext';
import { TourType } from 'models/widgetMultiStageOlympiad';

const MainPage = () => {
  const { banners } = useBannersContext({ section: 'main' });
  const userData = useUserData();
  const { years, lastAddedTimestamp } = useGratitudeCheck();

  const { multiStageWidgets } = useConfiguratorsContext();
  const priorityProjectsStore = usePriorityProjectsStore();

  return (
    <Container style={{ minHeight: 'calc(100vh - 71px)', height: '100%' }}>
      <Header>Главная</Header>
      <Space size={40} axis="vertical" />

      {banners.length ? (
        <>
          <Banners section="main" />
          <Space size={20} axis="vertical" />
        </>
      ) : null}

      {priorityProjectsStore.priorityProjects.length > 0 && (
        <>
          <PriorityProjects store={priorityProjectsStore} />
          <Space size={40} axis="vertical" />
        </>
      )}

      {userData?.azTests.enabledFunctionalLiteracyTasks ? (
        <>
          <FunctionalLiteracy />
          <Space size={40} axis="vertical" />
        </>
      ) : null}
      {userData?.azTests.enabledSafeTerritoryTasks ? (
        <>
          <SafeTerritory />
          <Space size={40} axis="vertical" />
        </>
      ) : null}
      {userData?.azTests.enabledInfoKpk ? (
        <>
          <Kpk />
          <Space axis="vertical" size={40} />
        </>
      ) : null}

      {multiStageWidgets.map(
        (widget) =>
          widget.showForRegion && (
            <RegionalRating
              key={widget.firstOlympId}
              widget={widget}
              isFirstFinished={
                widget.tourType === TourType.firstTourFinished ||
                widget.tourType === TourType.secondTourStarted ||
                widget.tourType === TourType.secondTourFinished
              }
              isSecondFinished={widget.tourType === TourType.secondTourFinished}
              isSecondStarted={widget.tourType === TourType.secondTourStarted}
            />
          ),
      )}

      <Wrap>
        {userData?.azTests.showVectorSurvey && (
          <VectorSurvey
            allowAutoOpenVectorSurvey={
              !!userData?.azTests.allowAutoOpenVectorSurvey && !!userData?.azTests.showVectorSurvey
            }
          />
        )}

        {multiStageWidgets.map(
          (widget) =>
            widget.showForMunicipality &&
            widget.tourType !== TourType.firstTourStarted && (
              <MultiStageOlympiad
                key={widget.firstOlympId}
                widget={widget}
                isFirstFinished={
                  widget.tourType === TourType.firstTourFinished ||
                  widget.tourType === TourType.secondTourStarted ||
                  widget.tourType === TourType.secondTourFinished
                }
                isSecondStarted={widget.tourType === TourType.secondTourStarted}
                isSecondFinished={widget.tourType === TourType.secondTourFinished}
              />
            ),
        )}
        {!userData?.azTests.disableRatingMechanics ? <Olympiads /> : null}
        <School />
        {/*disable widgets*/}
        {/*<Webinars />*/}
        {!!years.length && (userData?.userType != 'region' || userData.largeCity) && <Portfolio />}
      </Wrap>
    </Container>
  );
};

export default MainPage;
